export default "__VITE_ASSET__tvsiPVHm__"